/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Special_Event_Timer_Reward_Count_DownInputs */

const en_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("en", i?.day, {});
	if (dayPlural == "one") return /** @type {LocalizedString} */ (`Expires in 1 day`);
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`Expires in ${i?.day} days`);
	return /** @type {LocalizedString} */ (`Expires in ${i?.day} days`)
	
};

const ar_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("ar", i?.day, {});
	if (dayPlural == "zero") return /** @type {LocalizedString} */ (`تنتهي الصلاحية خلال ${i?.day} يوم`);
	if (dayPlural == "one") return /** @type {LocalizedString} */ (`تنتهي الصلاحية خلال يوم واحد`);
	if (dayPlural == "two") return /** @type {LocalizedString} */ (`تنتهي الصلاحية خلال يومين`);
	if (dayPlural == "few") return /** @type {LocalizedString} */ (`تنتهي الصلاحية خلال ${i?.day} أيام`);
	if (dayPlural == "many") return /** @type {LocalizedString} */ (`تنتهي الصلاحية خلال ${i?.day} يومًا`);
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`تنتهي الصلاحية خلال ${i?.day} يوم`);
	return /** @type {LocalizedString} */ (`تنتهي الصلاحية خلال ${i?.day} يوم`)
	
};

const de_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("de", i?.day, {});
	if (dayPlural == "one") return /** @type {LocalizedString} */ (`Läuft in ${i?.day} Tag ab`);
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`Läuft in ${i?.day} Tagen ab`);
	return /** @type {LocalizedString} */ (`Läuft in ${i?.day} Tagen ab`)
	
};

const es_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("es", i?.day, {});
	if (dayPlural == "one") return /** @type {LocalizedString} */ (`Caduca en ${i?.day} día`);
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`Caduca en ${i?.day} días`);
	return /** @type {LocalizedString} */ (`Caduca en ${i?.day} días`)
	
};

const fr_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("fr", i?.day, {});
	if (dayPlural == "one") return /** @type {LocalizedString} */ (`Expire dans ${i?.day} jour`);
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`Expire dans ${i?.day} jours`);
	return /** @type {LocalizedString} */ (`Expire dans ${i?.day} jours`)
	
};

const it_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("it", i?.day, {});
	if (dayPlural == "one") return /** @type {LocalizedString} */ (`Scade tra ${i?.day} giorno`);
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`Scade tra ${i?.day} giorni`);
	return /** @type {LocalizedString} */ (`Scade tra ${i?.day} giorni`)
	
};

const ja_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("ja", i?.day, {});
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`あと${i?.day}日で期限切れ`);
	return /** @type {LocalizedString} */ (`あと${i?.day}日で期限切れ`)
	
};

const ko_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("ko", i?.day, {});
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`만료까지 ${i?.day}일`);
	return /** @type {LocalizedString} */ (`만료까지 ${i?.day}일`)
	
};

const pt_br_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("pt_br", i?.day, {});
	if (dayPlural == "one") return /** @type {LocalizedString} */ (`Expira em ${i?.day} dia`);
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`Expira em ${i?.day} dias`);
	return /** @type {LocalizedString} */ (`Expira em ${i?.day} dias`)
	
};

const ru_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("ru", i?.day, {});
	if (dayPlural == "one") return /** @type {LocalizedString} */ (`Истекает через ${i?.day} день`);
	if (dayPlural == "few") return /** @type {LocalizedString} */ (`Истекает через ${i?.day} дня`);
	if (dayPlural == "many") return /** @type {LocalizedString} */ (`Истекает через ${i?.day} дней`);
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`Истекает через ${i?.day} дня`);
	return /** @type {LocalizedString} */ (`Истекает через ${i?.day} дня`)
	
};

const th_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("th", i?.day, {});
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`หมดอายุในอีก ${i?.day} วัน`);
	return /** @type {LocalizedString} */ (`หมดอายุในอีก ${i?.day} วัน`)
	
};

const tr_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("tr", i?.day, {});
	if (dayPlural == "one") return /** @type {LocalizedString} */ (`Süresi ${i?.day} gün içinde doluyor`);
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`Süresi ${i?.day} gün içinde doluyor`);
	return /** @type {LocalizedString} */ (`Süresi ${i?.day} gün içinde doluyor`)
	
};

const zh_cn_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("zh_cn", i?.day, {});
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`${i?.day} 天后过期`);
	return /** @type {LocalizedString} */ (`${i?.day} 天后过期`)
	
};

const zh_tw_special_event_timer_reward_count_down = /** @type {(inputs: Special_Event_Timer_Reward_Count_DownInputs) => LocalizedString} */ (i) => {const dayPlural = registry.plural("zh_tw", i?.day, {});
	if (dayPlural == "other") return /** @type {LocalizedString} */ (`${i?.day} 天後過期`);
	return /** @type {LocalizedString} */ (`${i?.day} 天後過期`)
	
};

/**
* | dayPlural | output |
* | --- | --- |
* | "one" | "Expires in 1 day" |
* | "other" | "Expires in {day} days" |
* | * | "Expires in {day} days" |
*
* @param {Special_Event_Timer_Reward_Count_DownInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const special_event_timer_reward_count_down = /** @type {((inputs: Special_Event_Timer_Reward_Count_DownInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Special_Event_Timer_Reward_Count_DownInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_special_event_timer_reward_count_down(inputs)
	if (locale === "ar") return ar_special_event_timer_reward_count_down(inputs)
	if (locale === "de") return de_special_event_timer_reward_count_down(inputs)
	if (locale === "es") return es_special_event_timer_reward_count_down(inputs)
	if (locale === "fr") return fr_special_event_timer_reward_count_down(inputs)
	if (locale === "it") return it_special_event_timer_reward_count_down(inputs)
	if (locale === "ja") return ja_special_event_timer_reward_count_down(inputs)
	if (locale === "ko") return ko_special_event_timer_reward_count_down(inputs)
	if (locale === "pt_br") return pt_br_special_event_timer_reward_count_down(inputs)
	if (locale === "ru") return ru_special_event_timer_reward_count_down(inputs)
	if (locale === "th") return th_special_event_timer_reward_count_down(inputs)
	if (locale === "tr") return tr_special_event_timer_reward_count_down(inputs)
	if (locale === "zh_cn") return zh_cn_special_event_timer_reward_count_down(inputs)
	return zh_tw_special_event_timer_reward_count_down(inputs)
});